module.exports = __webpack_public_path__ + "static/media/nr.9a67fa52.svg";